
var Model = require("./types/Model.js");

module.exports = Model({
	name: "selfdestructor",
	listeners: listeners
});

function listeners() {
	return {
		"mqtt:$/destroyed": quit
	};
}

function quit() {
	this.emit("logout:trigger:logout", {
		reason: "Destroyed"
	});
}
